Vue.component('clients', {
    data () {
        return {
            id: '',

            statusForm: $.extend(true, new Form({
                data: {
                    status: ''
                }
            }), {}),

            clients: [],

            loading: false,

            filter: {
                name: '',
                active: '1'
            }
        };
    },

    mounted () {
        this.getClients();
    },

    methods: {
        editStatus(id, status) {
            this.id = id;
            this.statusForm.data.status = status;
        },

        getClients () {
            this.loading = true;

            axios.get('/api/clients', {
                params: this.filter
            }).then((response) => {
                this.clients = response.data;
                this.loading = false;
            });
        },

        updateStatus () {
            Http.post('/api/clients/status/' + this.id, this.statusForm).then((response) => {
                // Reset, no need to display
                this.statusForm.resetForm();
                this.statusForm.resetAlert();

                this.getClients();

                this.id = '';

                $('#status').modal('hide');
            });
        }
    }
});